module.exports = __webpack_public_path__ + "media/images/redesign-images/sorority/sorority-custom-apparel-large-4656d7bd7924dfa7ad9b294b06ac683d.jpg";